module.exports = __webpack_public_path__ + "img/dd.f4e55b8f.png";